import React from 'react';
import styled from 'styled-components';
import images from 'rc-images';


const SearchIconImage = styled.button`
-moz-appearance: none;
-webkit-appearance: none;
background: none;
border: none;
outline: none;
&::-moz-focus-inner {
  border: 0;
}

&:focus {
  outline: none;
}


all: initial;
background-image: url(${images.searchIcon});
background-repeat: no-repeat;
position: absolute;
z-index: 200;
background-size: 21px;
background-position: center;
left: 2px;
bottom: -45px;
background-color: transparent;
border: none;
cursor: pointer;

@media screen and (min-width: 917px) {
  top: 0px;
}

@media screen and (min-width: 867px) and (max-width: 916px) {
  top: -8px;
}

@media screen and (min-width: 810px) and (max-width: 866px) {
  top: -18px;
}

@media screen and (min-width: 768px) and (max-width: 809px) {
  top: -26px;
}

@media screen and (min-width: 478px) and (max-width: 767px) {
  top: 3px;
}

@media screen and (min-width: 449px) and (max-width: 477px) {
  top: -6px;
}

@media screen and (min-width: 420px) and (max-width: 448px) {
  top: -18px;
}

@media screen and (min-width: 386px) and (max-width: 419px) {
  top: -30px;
}

@media screen and (min-width: 321px) and (max-width: 385px) {
  top: -40px;
}

@media screen and (max-width: 320px) {
  top: -60px;
}
`;

const EmptyText = styled.span`
  padding: 11px 17px;
  &::-moz-focus-inner {
    border: 0;
  }
  &:focus {
    outline: none;
  }
`;

const searchIcon = () => (
  <SearchIconImage tabIndex="0" aria-label="search material button">
    <EmptyText tabIndex="-1" />
  </SearchIconImage>
);

export default searchIcon;
